import React from "react";
import Layout from "./src/layouts";
// import { StoreProvider } from "./src/context/storeContext";
import { Toaster } from "react-hot-toast";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./src/assets/scss/style.scss";
import "./src/styles/globals.css";
import "./src/styles/tailwind.css";
export const wrapPageElement = ({ element, props }) => {
  return (
    <div>
      <Layout {...props}>{element}</Layout>;
      <Toaster />
    </div>
  );
};

// When ever we go to new page, it should start from the top of the page
export function shouldUpdateScroll({
  routerProps: { location },
  getSavedScrollPosition,
}) {
  const state = location?.state;
  if (state?.disableScrollUpdate) {
    return false;
  }

  const animationDuraion = 0.3;
  const scrollDelay = animationDuraion * 1000;

  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), scrollDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      scrollDelay
    );
  }

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  return false;
}
